function isSafari() {
    return /Apple/.test(navigator.userAgent) && /Apple/.test(navigator.vendor);
}

function isFirefox() {
    return /Firefox/.test(navigator.userAgent);
}

function isChrome() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}

export { isFirefox, isSafari, isChrome };
